/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const RouteIcon = ({
  className,
  style,
  color = '#A5BBD4',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.1665 16.6667C3.70625 16.6667 3.33317 16.2936 3.33317 15.8333C3.33317 15.3731 3.70625 15 4.1665 15C4.62675 15 4.99984 15.3731 4.99984 15.8333C4.99984 16.2936 4.62675 16.6667 4.1665 16.6667ZM4.1665 18.3333C2.78575 18.3333 1.6665 17.2141 1.6665 15.8333C1.6665 14.4526 2.78575 13.3333 4.1665 13.3333C5.54725 13.3333 6.6665 14.4526 6.6665 15.8333C6.6665 17.2141 5.54725 18.3333 4.1665 18.3333Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.08317 3.33334C8.23375 3.33334 9.1665 4.26608 9.1665 5.41667V14.5833C9.1665 16.6544 10.8454 18.3333 12.9165 18.3333C14.9876 18.3333 16.6665 16.6544 16.6665 14.5833V8.33334C16.6665 7.87311 16.2934 7.50001 15.8332 7.50001C15.3729 7.50001 14.9998 7.87311 14.9998 8.33334V14.5833C14.9998 15.7339 14.0671 16.6667 12.9165 16.6667C11.7659 16.6667 10.8332 15.7339 10.8332 14.5833V5.41667C10.8332 3.34561 9.15425 1.66667 7.08317 1.66667C5.01209 1.66667 3.33317 3.34561 3.33317 5.41667V10.8333C3.33317 11.2936 3.70625 11.6667 4.1665 11.6667C4.62675 11.6667 4.99984 11.2936 4.99984 10.8333V5.41667C4.99984 4.26608 5.93259 3.33334 7.08317 3.33334Z"
        fill={color}
      />
      <path
        d="M16.5532 2.06731C16.2317 1.51606 15.4352 1.51606 15.1136 2.06731L13.6478 4.58012C13.3237 5.13567 13.7244 5.83334 14.3676 5.83334H17.2992C17.9424 5.83334 18.3431 5.13567 18.019 4.58012L16.5532 2.06731Z"
        fill={color}
      />
    </svg>
  );
};
